export var PRODUCT_LABELS_FRAGMENT = "\n  fragment ProductLabels on ProductLabel {\n    labelKey\n    productLabelDomain\n    title\n  }\n";
//# sourceMappingURL=labels.js.map